import { useQuery } from '@tanstack/react-query';

import { callService } from '@api/remote-call';
import { HotelDetailViewModel } from '@api/v3';

export const useGetHotelRecommendations = (
  data?: HotelDetailViewModel,
  startDate?: string,
  endDate?: string
) => {
  const { data: hotelRecommendations } = useQuery(
    ['hotelRecommendations', data?.id],
    () =>
      callService(
        {
          service: 'HotelsService',
          method: 'hotelRecommendations',
          version: 'v3',
        },
        {
          body: {
            selectedHotelId: data?.id || 0,
            listedHotelIds: [],
            overseas:
              data?.countryCode === 'TR' || data?.countryCode === 'CY'
                ? false
                : true,
            in: startDate,
            out: endDate,
            page: 0,
            size: 20,
          },
        }
      ),
    {
      enabled: Boolean(
        data &&
          data.id &&
          (data?.countryCode === 'TR' || data?.countryCode === 'CY')
      ),
    }
  );
  return {
    hotelRecommendations,
  };
};
